import type { RawProductData } from '@packages/product/src/types';
import { useHashParameters } from '@packages/modules/src/hooks/useHashParameters/useHashParameters';
import { MiraklProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/MiraklProductsRecoSlider/MiraklProductsRecoSlider.client';
import { PrudsysAddToBasketRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/PrudsysAddToBasketRecoSlider/PrudsysAddToBasketRecoSlider.client';
import { SearchBasketToProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/SearchBasketToProductsRecoSlider/SearchBasketToProductsRecoSlider.client';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useIntl } from 'react-intl';
import { addToBasketRecommendationsMessages } from './messages';

export type AddToBasketRecommendationsData = Pick<
  RawProductData,
  'akl' | 'availability' | 'brand' | 'defaultCategory' | 'hasSeries' | 'orderNumber'
> & {
  price: { value: number };
};

type AddToBasketRecommendationsProps = {
  data: AddToBasketRecommendationsData;
};

export const AddToBasketRecommendations = ({ data }: AddToBasketRecommendationsProps) => {
  const { formatMessage } = useIntl();
  const { category = '' } = useHashParameters();
  const {
    product: {
      recommendations: {
        atb: {
          slots: { '1': recoSlot1, '2': recoSlot2 },
        },
      },
    },
  } = useConfig();

  const { akl, brand, defaultCategory, orderNumber, hasSeries, price, availability } = data;

  return (
    <>
      {
        {
          prudsysAddToBasket: (
            <PrudsysAddToBasketRecoSlider
              brand={brand?.name ?? ''}
              categoryIds={[defaultCategory ?? category]}
              productId={orderNumber}
              title={formatMessage(addToBasketRecommendationsMessages.prudsysFallback)}
            />
          ),
          searchBasketToProducts: (
            <SearchBasketToProductsRecoSlider
              aklIds={[akl]}
              title={formatMessage(addToBasketRecommendationsMessages.prudsysFallback)}
            />
          ),
        }[recoSlot1]
      }
      {recoSlot2 === 'miraklProducts' && (
        <MiraklProductsRecoSlider
          productId={orderNumber}
          fetchOnThreshold
          title={formatMessage(addToBasketRecommendationsMessages.criteoFallback)}
          key={`${orderNumber}2`}
        />
      )}
    </>
  );
};
